// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fatura-page {
    padding: 16px;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.fatura-header-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.fatura-header {
    text-align: center;
    padding: 16px 0;
}

.fatura-filters-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-item {
    margin-bottom: 8px;
}

.filter-item .ant-typography {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    color: #666;
}

.filter-actions {
    display: flex;
    align-items: flex-end;
    height: 100%;
    padding-top: 20px;
}

.fatura-content-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* table-layout bir DIV'de gecersizdir (.ant-table bir div); width:100%!important
   ise ic <table>'in yatay kaydirma icin ihtiyac duydugu genislemeyi kisitlar.
   Sarmalayici zaten blok eleman, min-width yeterli. */
.fatura-content-card .ant-table {
    min-width: 100%;
}

.fatura-content-card .ant-table-container {
    width: 100% !important;
}

.fatura-content-card .ant-table-tbody > tr > td {
    padding: 2px 4px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    height: auto !important;
    text-overflow: clip !important;
}

.fatura-content-card .ant-table-tbody > tr > td > div,
.fatura-content-card .ant-table-tbody > tr > td > span {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    max-width: 100% !important;
    text-overflow: clip !important;
    display: block !important;
}

.fatura-content-card .ant-table-tbody > tr {
    height: auto !important;
}

.fatura-content-card .ant-table-tbody > tr > td * {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr {
    height: auto !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td * {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.fatura-content-card .ant-table-thead > tr > th {
    padding: 4px 6px !important;
    font-weight: 400 !important;
    background-color: #fafafa;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
}

.fatura-content-card .ant-table-tbody > tr:hover > td {
    background-color: #f5f5f5;
}

.fatura-content-card .ant-tabs-tab {
    font-weight: 500;
    padding: 12px 16px;
}

.fatura-content-card .ant-tabs-tab-active {
    color: #1890ff;
}

.fatura-content-card .ant-tabs-ink-bar {
    background: #1890ff;
}

.fatura-actions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;
}

.fatura-content-card .ant-table {
    border-radius: 6px;
}

.fatura-content-card .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
    padding: 4px 6px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
}

.fatura-content-card .ant-table-thead > tr > th .ant-table-column-sorter {
    display: none !important;
}

.fatura-content-card .ant-table-thead > tr > th .ant-table-column-sorter .anticon {
    display: none !important;
}

.fatura-content-card .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
    height: 20px !important;
    padding: 2px 6px !important;
    line-height: 1.2 !important;
}

.fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {
    font-size: 10px !important;
}

.fatura-content-card .ant-table-thead > tr > th .ant-btn {
    font-size: 10px !important;
    height: 16px !important;
    padding: 0 2px !important;
    line-height: 1.2 !important;
}

.fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {
    font-size: 10px !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
    height: 20px !important;
    padding: 2px 6px !important;
    line-height: 1.2 !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {
    font-size: 10px !important;
}

.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn {
    font-size: 10px !important;
    height: 16px !important;
    padding: 0 2px !important;
    line-height: 1.2 !important;
}

.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {
    font-size: 10px !important;
}

.fatura-content-card .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
    height: 20px !important;
    padding: 2px 6px !important;
    line-height: 1.2 !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {
    font-size: 10px !important;
}

.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn {
    font-size: 10px !important;
    height: 16px !important;
    padding: 0 2px !important;
    line-height: 1.2 !important;
}

.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {
    font-size: 10px !important;
}

.fatura-content-card .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.fatura-content-card .ant-pagination {
    margin-top: 16px;
    text-align: right;
}

@media (max-width: 1200px) {
    .fatura-page {
        padding: 12px;
    }
}

@media (max-width: 768px) {
    .fatura-page {
        padding: 8px;
    }
    
    .filter-actions {
        padding-top: 8px;
    }
    
    .fatura-actions {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .fatura-content-card .ant-tabs-tab {
        padding: 8px 12px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .fatura-page {
        padding: 4px;
    }
    
    .fatura-header {
        padding: 8px 0;
    }
    
    .filter-actions {
        padding-top: 4px;
    }
    
    .fatura-actions {
        flex-direction: column;
        align-items: stretch;
    }
    
    .fatura-actions .ant-btn {
        margin-bottom: 4px;
    }
}

.dark-theme .fatura-page {
    background-color: var(--dark-bg);
}

.dark-theme .fatura-header-card,
.dark-theme .fatura-filters-card,
.dark-theme .fatura-content-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .fatura-content-card .ant-table-thead > tr > th {
    background-color: var(--dark-bg-header) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 4px 6px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr:hover > td {
    background-color: var(--dark-bg-header) !important;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    height: auto !important;
    text-overflow: clip !important;
}

.dark-theme .fatura-content-card .ant-table-tbody > tr > td {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    height: auto !important;
    text-overflow: clip !important;
}

.dark-theme .filter-item .ant-typography {
    color: var(--dark-text) !important;
}

.dark-theme .dark-button {
    background-color: var(--dark-bg-header) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-button:hover {
    background-color: var(--dark-bg) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
}

.dark-theme .dark-input {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-input:hover {
    border-color: var(--color-primary) !important;
}

.dark-theme .dark-input:focus {
    border-color: var(--color-primary) !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

.dark-theme .dark-select .ant-select-selector {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-select .ant-select-selection-item {
    color: var(--dark-text) !important;
}

.dark-theme .dark-select .ant-select-selection-placeholder {
    color: var(--dark-text-muted) !important;
}

.dark-theme .dark-date-picker .ant-picker-input > input {
    background-color: var(--dark-bg) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-date-picker .ant-picker-suffix {
    color: var(--dark-text-muted) !important;
}

.dark-theme .dark-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .dark-card .ant-card-head {
    background-color: var(--dark-bg-header) !important;
    border-bottom-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-card .ant-card-body {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
}

.fatura-content-card .ant-spin-container {
    min-height: 200px;
}

.fatura-content-card .ant-alert {
    border-radius: 6px;
}

.fatura-content-card .ant-empty {
    padding: 40px 0;
}

.fatura-content-card .ant-table-body::-webkit-scrollbar {
    height: 8px;
}

.fatura-content-card .ant-table-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.fatura-content-card .ant-table-body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.fatura-content-card .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.sabit-kira-page {
    padding: 20px;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.sabit-kira-page .ant-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sabit-kira-page .ant-table {
    border-radius: 6px;
}

.sabit-kira-page .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
    padding: 12px;
}

.sabit-kira-page .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    padding: 8px 12px;
}

.sabit-kira-page .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
}

.sabit-kira-page .ant-form-item-label > label {
    font-weight: 500;
    color: #262626;
}

.sabit-kira-page .ant-input,
.sabit-kira-page .ant-select-selector,
.sabit-kira-page .ant-picker {
    border-radius: 6px;
}

.sabit-kira-page .ant-btn {
    border-radius: 6px;
    font-weight: 500;
}

.sabit-kira-page .ant-btn-primary {
    background: #1890ff;
    border-color: #1890ff;
}

.sabit-kira-page .ant-btn-primary:hover {
    background: #40a9ff;
    border-color: #40a9ff;
}

.dark-theme .sabit-kira-page {
    background-color: var(--dark-bg);
}

.dark-theme .sabit-kira-page .ant-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .sabit-kira-page .ant-card-head {
    background-color: var(--dark-bg-header) !important;
    border-bottom-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .ant-card-body {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .ant-table-thead > tr > th {
    background: var(--dark-bg-header) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
}

.dark-theme .sabit-kira-page .ant-table-tbody > tr > td {
    background: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
}

.dark-theme .sabit-kira-page .ant-table-tbody > tr:hover > td {
    background: var(--dark-bg-header) !important;
}

.dark-theme .sabit-kira-page .ant-form-item-label > label {
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-input {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-input:hover {
    border-color: var(--color-primary) !important;
}

.dark-theme .sabit-kira-page .dark-input:focus {
    border-color: var(--color-primary) !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

.dark-theme .sabit-kira-page .dark-select .ant-select-selector {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-select .ant-select-selection-item {
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-select .ant-select-selection-placeholder {
    color: var(--dark-text-muted) !important;
}

.dark-theme .sabit-kira-page .dark-date-picker .ant-picker-input > input {
    background-color: var(--dark-bg) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-date-picker .ant-picker-suffix {
    color: var(--dark-text-muted) !important;
}

.dark-theme .sabit-kira-page .dark-button {
    background-color: var(--dark-bg-header) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .sabit-kira-page .dark-button:hover {
    background-color: var(--dark-bg) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
}

.dark-theme .sabit-kira-page .dark-form .ant-form-item-label > label {
    color: var(--dark-text) !important;
}

@media (max-width: 1200px) {
    .sabit-kira-page {
        padding: 16px;
    }
}

@media (max-width: 768px) {
    .sabit-kira-page {
        padding: 12px;
    }
    
    .sabit-kira-page .ant-card {
        margin-bottom: 16px;
    }
}

@media (max-width: 480px) {
    .sabit-kira-page {
        padding: 8px;
    }
    
    .sabit-kira-page .ant-card {
        margin-bottom: 12px;
    }
    
    .sabit-kira-page .ant-table-thead > tr > th,
    .sabit-kira-page .ant-table-tbody > tr > td {
        padding: 6px 8px;
        font-size: 12px;
    }
}

.expired-row {
    background-color: #ffebee !important;
    color: #c62828 !important;
}

.expired-row:hover {
    background-color: #ffcdd2 !important;
}

.approaching-row {
    background-color: #fff3e0 !important;
    color: #ef6c00 !important;
}

.approaching-row:hover {
    background-color: #ffe0b2 !important;
}

[data-theme="dark"] .expired-row {
    background-color: #4a1a1a !important;
    color: #ffcdd2 !important;
}

[data-theme="dark"] .expired-row:hover {
    background-color: #5d1f1f !important;
}

[data-theme="dark"] .approaching-row {
    background-color: #4a2c00 !important;
    color: #ffb74d !important;
}

[data-theme="dark"] .approaching-row:hover {
    background-color: #5d3700 !important;
}

.expired-date {
    color: #c62828 !important;
    font-weight: bold;
}

.approaching-date {
    color: #ef6c00 !important;
    font-weight: bold;
}

[data-theme="dark"] .expired-date {
    color: #ffcdd2 !important;
}

[data-theme="dark"] .approaching-date {
    color: #ffb74d !important;
}

.weekend-row {
    background-color: #fff2f0 !important;
}

.weekend-row td {
    background-color: #fff2f0 !important;
    color: #d32f2f !important;
}

.weekday-row {
    background-color: #f6ffed !important;
}

.weekday-row td {
    background-color: #f6ffed !important;
    color: #2e7d32 !important;
}

.ant-table-tbody > tr.weekend-row {
    background-color: #fff2f0 !important;
}

.ant-table-tbody > tr.weekend-row > td {
    background-color: #fff2f0 !important;
    color: #d32f2f !important;
}

.ant-table-tbody > tr.weekday-row {
    background-color: #f6ffed !important;
}

.ant-table-tbody > tr.weekday-row > td {
    background-color: #f6ffed !important;
    color: #2e7d32 !important;
}

.dark-theme .weekend-row {
    background-color: rgba(255, 77, 79, 0.1) !important;
}

.dark-theme .weekend-row td {
    background-color: rgba(255, 77, 79, 0.1) !important;
    color: #ff6b6b !important;
}

.dark-theme .weekday-row {
    background-color: rgba(82, 196, 26, 0.1) !important;
}

.dark-theme .weekday-row td {
    background-color: rgba(82, 196, 26, 0.1) !important;
    color: #69f0ae !important;
}

.dark-theme .ant-table-tbody > tr.weekend-row {
    background-color: rgba(255, 77, 79, 0.1) !important;
}

.dark-theme .ant-table-tbody > tr.weekend-row > td {
    background-color: rgba(255, 77, 79, 0.1) !important;
    color: #ff6b6b !important;
}

.dark-theme .ant-table-tbody > tr.weekday-row {
    background-color: rgba(82, 196, 26, 0.1) !important;
}

.dark-theme .ant-table-tbody > tr.weekday-row > td {
    background-color: rgba(82, 196, 26, 0.1) !important;
    color: #69f0ae !important;
}

/* Dark Modal Styles */
.dark-modal .ant-modal-content {
    background-color: var(--dark-bg-secondary) !important;
    border: 1px solid var(--dark-border) !important;
}

.dark-modal .ant-modal-header {
    background-color: var(--dark-bg-header) !important;
    border-bottom: 1px solid var(--dark-border) !important;
}

.dark-modal .ant-modal-title {
    color: var(--dark-text) !important;
}

.dark-modal .ant-modal-body {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
}

.dark-modal .ant-modal-footer {
    background-color: var(--dark-bg-secondary) !important;
    border-top: 1px solid var(--dark-border) !important;
}

.dark-modal .ant-modal-close {
    color: var(--dark-text) !important;
}

.dark-modal .ant-modal-close:hover {
    background-color: var(--dark-bg-hover) !important;
}

.green {
    color: #52c41a !important;
    font-weight: 500;
}

.red {
    color: #ff4d4f !important;
    font-weight: 500;
}

.blue {
    color: #1890ff !important;
    font-weight: 500;
}

.orange {
    color: #fa8c16 !important;
    font-weight: 500;
}

[data-theme="dark"] .green {
    color: #73d13d !important;
}

[data-theme="dark"] .red {
    color: #ff7875 !important;
}

[data-theme="dark"] .blue {
    color: #40a9ff !important;
}

[data-theme="dark"] .orange {
    color: #ffa940 !important;
}

.expired-row {
    border-left: 4px solid #ff4d4f !important;
    background-color: rgba(255, 77, 79, 0.05) !important;
}

.expired-row:hover {
    background-color: rgba(255, 77, 79, 0.1) !important;
}

[data-theme="dark"] .expired-row {
    border-left: 4px solid #ff7875 !important;
    background-color: rgba(255, 120, 117, 0.1) !important;
}

[data-theme="dark"] .expired-row:hover {
    background-color: rgba(255, 120, 117, 0.15) !important;
}

.demirbas-detail-modal .ant-modal-body .ant-table-thead > tr > th {
    font-size: 10px !important;
    padding: 4px !important;
}
.demirbas-detail-modal .ant-modal-body .ant-table-tbody > tr > td {
    font-size: 10px !important;
    padding: 4px !important;
}
.demirbas-detail-modal .ant-modal-body .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
}
.demirbas-detail-modal .ant-modal-body .ant-pagination {
    font-size: 10px !important;
}
.demirbas-detail-modal .ant-modal-body .ant-pagination .ant-select-selector,
.demirbas-detail-modal .ant-modal-body .ant-pagination-item {
    font-size: 10px !important;
}
.demirbas-detail-modal .ant-modal-title {
    font-size: 12px !important;
}
/* 27.10: dönemi ödenmiş (yeni sistem ya da eski Fedora) kalem */
.fatura-page .fatura-satir-pasif > td {
    opacity: 0.5;
}
.fatura-page .fatura-satir-pasif > td.ant-table-cell-fix-right {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/fatura/FaturaPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;;sDAEsD;AACtD;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;IAGI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kCAAkC;IAClC,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;IAClC,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,wDAAwD;AAC5D;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,4CAA4C;IAC5C,kCAAkC;IAClC,kDAAkD;AACtD;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,kDAAkD;AACtD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,wDAAwD;AAC5D;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,qDAAqD;IACrD,+CAA+C;AACnD;;AAEA;IACI,kDAAkD;IAClD,sDAAsD;AAC1D;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,mDAAmD;AACvD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,oDAAoD;AACxD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,yCAAyC;IACzC,qDAAqD;AACzD;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;AACA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA,gEAAgE;AAChE;IACI,YAAY;AAChB;AACA;IACI,UAAU;AACd","sourcesContent":[".fatura-page {\n    padding: 16px;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n\n.fatura-header-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.fatura-header {\n    text-align: center;\n    padding: 16px 0;\n}\n\n.fatura-filters-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.filter-item {\n    margin-bottom: 8px;\n}\n\n.filter-item .ant-typography {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: #666;\n}\n\n.filter-actions {\n    display: flex;\n    align-items: flex-end;\n    height: 100%;\n    padding-top: 20px;\n}\n\n.fatura-content-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* table-layout bir DIV'de gecersizdir (.ant-table bir div); width:100%!important\n   ise ic <table>'in yatay kaydirma icin ihtiyac duydugu genislemeyi kisitlar.\n   Sarmalayici zaten blok eleman, min-width yeterli. */\n.fatura-content-card .ant-table {\n    min-width: 100%;\n}\n\n.fatura-content-card .ant-table-container {\n    width: 100% !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td {\n    padding: 2px 4px !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td > div,\n.fatura-content-card .ant-table-tbody > tr > td > span {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    max-width: 100% !important;\n    text-overflow: clip !important;\n    display: block !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr {\n    height: auto !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td * {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr {\n    height: auto !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td * {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.fatura-content-card .ant-table-thead > tr > th {\n    padding: 4px 6px !important;\n    font-weight: 400 !important;\n    background-color: #fafafa;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr:hover > td {\n    background-color: #f5f5f5;\n}\n\n.fatura-content-card .ant-tabs-tab {\n    font-weight: 500;\n    padding: 12px 16px;\n}\n\n.fatura-content-card .ant-tabs-tab-active {\n    color: #1890ff;\n}\n\n.fatura-content-card .ant-tabs-ink-bar {\n    background: #1890ff;\n}\n\n.fatura-actions {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n    margin-bottom: 16px;\n}\n\n.fatura-content-card .ant-table {\n    border-radius: 6px;\n}\n\n.fatura-content-card .ant-table-thead > tr > th {\n    background: #fafafa;\n    font-weight: 600;\n    color: #262626;\n    border-bottom: 2px solid #f0f0f0;\n    padding: 4px 6px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n}\n\n.fatura-content-card .ant-table-thead > tr > th .ant-table-column-sorter {\n    display: none !important;\n}\n\n.fatura-content-card .ant-table-thead > tr > th .ant-table-column-sorter .anticon {\n    display: none !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n    height: 20px !important;\n    padding: 2px 6px !important;\n    line-height: 1.2 !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.fatura-content-card .ant-table-thead > tr > th .ant-btn {\n    font-size: 10px !important;\n    height: 16px !important;\n    padding: 0 2px !important;\n    line-height: 1.2 !important;\n}\n\n.fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n    height: 20px !important;\n    padding: 2px 6px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn {\n    font-size: 10px !important;\n    height: 16px !important;\n    padding: 0 2px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr:hover > td {\n    background: #f5f5f5;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n    height: 20px !important;\n    padding: 2px 6px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn {\n    font-size: 10px !important;\n    height: 16px !important;\n    padding: 0 2px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-thead > tr > th .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.fatura-content-card .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f0f0f0;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.fatura-content-card .ant-pagination {\n    margin-top: 16px;\n    text-align: right;\n}\n\n@media (max-width: 1200px) {\n    .fatura-page {\n        padding: 12px;\n    }\n}\n\n@media (max-width: 768px) {\n    .fatura-page {\n        padding: 8px;\n    }\n    \n    .filter-actions {\n        padding-top: 8px;\n    }\n    \n    .fatura-actions {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n    \n    .fatura-content-card .ant-tabs-tab {\n        padding: 8px 12px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .fatura-page {\n        padding: 4px;\n    }\n    \n    .fatura-header {\n        padding: 8px 0;\n    }\n    \n    .filter-actions {\n        padding-top: 4px;\n    }\n    \n    .fatura-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .fatura-actions .ant-btn {\n        margin-bottom: 4px;\n    }\n}\n\n.dark-theme .fatura-page {\n    background-color: var(--dark-bg);\n}\n\n.dark-theme .fatura-header-card,\n.dark-theme .fatura-filters-card,\n.dark-theme .fatura-content-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-thead > tr > th {\n    background-color: var(--dark-bg-header) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 4px 6px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    font-weight: 600 !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr:hover > td {\n    background-color: var(--dark-bg-header) !important;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.dark-theme .fatura-content-card .ant-table-tbody > tr > td {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.dark-theme .filter-item .ant-typography {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-button {\n    background-color: var(--dark-bg-header) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-button:hover {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--color-primary) !important;\n    color: var(--color-primary) !important;\n}\n\n.dark-theme .dark-input {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-input:hover {\n    border-color: var(--color-primary) !important;\n}\n\n.dark-theme .dark-input:focus {\n    border-color: var(--color-primary) !important;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n}\n\n.dark-theme .dark-select .ant-select-selector {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-select .ant-select-selection-item {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-select .ant-select-selection-placeholder {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .dark-date-picker .ant-picker-input > input {\n    background-color: var(--dark-bg) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-date-picker .ant-picker-suffix {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .dark-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .dark-card .ant-card-head {\n    background-color: var(--dark-bg-header) !important;\n    border-bottom-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-card .ant-card-body {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n}\n\n.fatura-content-card .ant-spin-container {\n    min-height: 200px;\n}\n\n.fatura-content-card .ant-alert {\n    border-radius: 6px;\n}\n\n.fatura-content-card .ant-empty {\n    padding: 40px 0;\n}\n\n.fatura-content-card .ant-table-body::-webkit-scrollbar {\n    height: 8px;\n}\n\n.fatura-content-card .ant-table-body::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.fatura-content-card .ant-table-body::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n}\n\n.fatura-content-card .ant-table-body::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n.sabit-kira-page {\n    padding: 20px;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n\n.sabit-kira-page .ant-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sabit-kira-page .ant-table {\n    border-radius: 6px;\n}\n\n.sabit-kira-page .ant-table-thead > tr > th {\n    background: #fafafa;\n    font-weight: 600;\n    color: #262626;\n    border-bottom: 2px solid #f0f0f0;\n    padding: 12px;\n}\n\n.sabit-kira-page .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f0f0f0;\n    padding: 8px 12px;\n}\n\n.sabit-kira-page .ant-table-tbody > tr:hover > td {\n    background: #f5f5f5;\n}\n\n.sabit-kira-page .ant-form-item-label > label {\n    font-weight: 500;\n    color: #262626;\n}\n\n.sabit-kira-page .ant-input,\n.sabit-kira-page .ant-select-selector,\n.sabit-kira-page .ant-picker {\n    border-radius: 6px;\n}\n\n.sabit-kira-page .ant-btn {\n    border-radius: 6px;\n    font-weight: 500;\n}\n\n.sabit-kira-page .ant-btn-primary {\n    background: #1890ff;\n    border-color: #1890ff;\n}\n\n.sabit-kira-page .ant-btn-primary:hover {\n    background: #40a9ff;\n    border-color: #40a9ff;\n}\n\n.dark-theme .sabit-kira-page {\n    background-color: var(--dark-bg);\n}\n\n.dark-theme .sabit-kira-page .ant-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-card-head {\n    background-color: var(--dark-bg-header) !important;\n    border-bottom-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-card-body {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-table-thead > tr > th {\n    background: var(--dark-bg-header) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-table-tbody > tr > td {\n    background: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-table-tbody > tr:hover > td {\n    background: var(--dark-bg-header) !important;\n}\n\n.dark-theme .sabit-kira-page .ant-form-item-label > label {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-input {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-input:hover {\n    border-color: var(--color-primary) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-input:focus {\n    border-color: var(--color-primary) !important;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-select .ant-select-selector {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-select .ant-select-selection-item {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-select .ant-select-selection-placeholder {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-date-picker .ant-picker-input > input {\n    background-color: var(--dark-bg) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-date-picker .ant-picker-suffix {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-button {\n    background-color: var(--dark-bg-header) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-button:hover {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--color-primary) !important;\n    color: var(--color-primary) !important;\n}\n\n.dark-theme .sabit-kira-page .dark-form .ant-form-item-label > label {\n    color: var(--dark-text) !important;\n}\n\n@media (max-width: 1200px) {\n    .sabit-kira-page {\n        padding: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .sabit-kira-page {\n        padding: 12px;\n    }\n    \n    .sabit-kira-page .ant-card {\n        margin-bottom: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .sabit-kira-page {\n        padding: 8px;\n    }\n    \n    .sabit-kira-page .ant-card {\n        margin-bottom: 12px;\n    }\n    \n    .sabit-kira-page .ant-table-thead > tr > th,\n    .sabit-kira-page .ant-table-tbody > tr > td {\n        padding: 6px 8px;\n        font-size: 12px;\n    }\n}\n\n.expired-row {\n    background-color: #ffebee !important;\n    color: #c62828 !important;\n}\n\n.expired-row:hover {\n    background-color: #ffcdd2 !important;\n}\n\n.approaching-row {\n    background-color: #fff3e0 !important;\n    color: #ef6c00 !important;\n}\n\n.approaching-row:hover {\n    background-color: #ffe0b2 !important;\n}\n\n[data-theme=\"dark\"] .expired-row {\n    background-color: #4a1a1a !important;\n    color: #ffcdd2 !important;\n}\n\n[data-theme=\"dark\"] .expired-row:hover {\n    background-color: #5d1f1f !important;\n}\n\n[data-theme=\"dark\"] .approaching-row {\n    background-color: #4a2c00 !important;\n    color: #ffb74d !important;\n}\n\n[data-theme=\"dark\"] .approaching-row:hover {\n    background-color: #5d3700 !important;\n}\n\n.expired-date {\n    color: #c62828 !important;\n    font-weight: bold;\n}\n\n.approaching-date {\n    color: #ef6c00 !important;\n    font-weight: bold;\n}\n\n[data-theme=\"dark\"] .expired-date {\n    color: #ffcdd2 !important;\n}\n\n[data-theme=\"dark\"] .approaching-date {\n    color: #ffb74d !important;\n}\n\n.weekend-row {\n    background-color: #fff2f0 !important;\n}\n\n.weekend-row td {\n    background-color: #fff2f0 !important;\n    color: #d32f2f !important;\n}\n\n.weekday-row {\n    background-color: #f6ffed !important;\n}\n\n.weekday-row td {\n    background-color: #f6ffed !important;\n    color: #2e7d32 !important;\n}\n\n.ant-table-tbody > tr.weekend-row {\n    background-color: #fff2f0 !important;\n}\n\n.ant-table-tbody > tr.weekend-row > td {\n    background-color: #fff2f0 !important;\n    color: #d32f2f !important;\n}\n\n.ant-table-tbody > tr.weekday-row {\n    background-color: #f6ffed !important;\n}\n\n.ant-table-tbody > tr.weekday-row > td {\n    background-color: #f6ffed !important;\n    color: #2e7d32 !important;\n}\n\n.dark-theme .weekend-row {\n    background-color: rgba(255, 77, 79, 0.1) !important;\n}\n\n.dark-theme .weekend-row td {\n    background-color: rgba(255, 77, 79, 0.1) !important;\n    color: #ff6b6b !important;\n}\n\n.dark-theme .weekday-row {\n    background-color: rgba(82, 196, 26, 0.1) !important;\n}\n\n.dark-theme .weekday-row td {\n    background-color: rgba(82, 196, 26, 0.1) !important;\n    color: #69f0ae !important;\n}\n\n.dark-theme .ant-table-tbody > tr.weekend-row {\n    background-color: rgba(255, 77, 79, 0.1) !important;\n}\n\n.dark-theme .ant-table-tbody > tr.weekend-row > td {\n    background-color: rgba(255, 77, 79, 0.1) !important;\n    color: #ff6b6b !important;\n}\n\n.dark-theme .ant-table-tbody > tr.weekday-row {\n    background-color: rgba(82, 196, 26, 0.1) !important;\n}\n\n.dark-theme .ant-table-tbody > tr.weekday-row > td {\n    background-color: rgba(82, 196, 26, 0.1) !important;\n    color: #69f0ae !important;\n}\n\n/* Dark Modal Styles */\n.dark-modal .ant-modal-content {\n    background-color: var(--dark-bg-secondary) !important;\n    border: 1px solid var(--dark-border) !important;\n}\n\n.dark-modal .ant-modal-header {\n    background-color: var(--dark-bg-header) !important;\n    border-bottom: 1px solid var(--dark-border) !important;\n}\n\n.dark-modal .ant-modal-title {\n    color: var(--dark-text) !important;\n}\n\n.dark-modal .ant-modal-body {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-modal .ant-modal-footer {\n    background-color: var(--dark-bg-secondary) !important;\n    border-top: 1px solid var(--dark-border) !important;\n}\n\n.dark-modal .ant-modal-close {\n    color: var(--dark-text) !important;\n}\n\n.dark-modal .ant-modal-close:hover {\n    background-color: var(--dark-bg-hover) !important;\n}\n\n.green {\n    color: #52c41a !important;\n    font-weight: 500;\n}\n\n.red {\n    color: #ff4d4f !important;\n    font-weight: 500;\n}\n\n.blue {\n    color: #1890ff !important;\n    font-weight: 500;\n}\n\n.orange {\n    color: #fa8c16 !important;\n    font-weight: 500;\n}\n\n[data-theme=\"dark\"] .green {\n    color: #73d13d !important;\n}\n\n[data-theme=\"dark\"] .red {\n    color: #ff7875 !important;\n}\n\n[data-theme=\"dark\"] .blue {\n    color: #40a9ff !important;\n}\n\n[data-theme=\"dark\"] .orange {\n    color: #ffa940 !important;\n}\n\n.expired-row {\n    border-left: 4px solid #ff4d4f !important;\n    background-color: rgba(255, 77, 79, 0.05) !important;\n}\n\n.expired-row:hover {\n    background-color: rgba(255, 77, 79, 0.1) !important;\n}\n\n[data-theme=\"dark\"] .expired-row {\n    border-left: 4px solid #ff7875 !important;\n    background-color: rgba(255, 120, 117, 0.1) !important;\n}\n\n[data-theme=\"dark\"] .expired-row:hover {\n    background-color: rgba(255, 120, 117, 0.15) !important;\n}\n\n.demirbas-detail-modal .ant-modal-body .ant-table-thead > tr > th {\n    font-size: 10px !important;\n    padding: 4px !important;\n}\n.demirbas-detail-modal .ant-modal-body .ant-table-tbody > tr > td {\n    font-size: 10px !important;\n    padding: 4px !important;\n}\n.demirbas-detail-modal .ant-modal-body .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n}\n.demirbas-detail-modal .ant-modal-body .ant-pagination {\n    font-size: 10px !important;\n}\n.demirbas-detail-modal .ant-modal-body .ant-pagination .ant-select-selector,\n.demirbas-detail-modal .ant-modal-body .ant-pagination-item {\n    font-size: 10px !important;\n}\n.demirbas-detail-modal .ant-modal-title {\n    font-size: 12px !important;\n}\n/* 27.10: dönemi ödenmiş (yeni sistem ya da eski Fedora) kalem */\n.fatura-page .fatura-satir-pasif > td {\n    opacity: 0.5;\n}\n.fatura-page .fatura-satir-pasif > td.ant-table-cell-fix-right {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
